import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { I18nService, StorageService } from './services/general-utils';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppRoutingModule } from '../app-routing.module';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip'
import { SharedModule } from '../shared/shared.module';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthGuard } from './guards/auth.guard';
// import { RouterBackService } from './services';
import { NgProgressModule } from 'ngx-progressbar';
import { SpinnerModule } from '../shared/components/spinner/spinner.module';
import { NgxWebstorageModule } from 'ngx-webstorage';
// import { ErrorComponent } from './layouts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { FormUtilsService } from './services/form-utils.service';
import { RestHttpInterceptor } from './interceptors/rest-http.interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor';
import { MainComponent } from './layouts/main/main.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserService } from './services/rest/user.service';
import { AccountService } from './services/rest/account.service';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { StateStorageService } from './services/general-utils/state-storage.service';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { CambiService } from './services/rest/cambi.service';
import { UtilsService } from './services/general-utils/utils.service';
import { SimulativoService } from './services/rest/simulativo.service';
import { PricingService } from './services/rest/pricing.service';
import { DominioCrossService } from './services/rest/dominio-cross.service';
import { GroupService } from './services/rest/group.service';
import { QlikService } from './services/rest/qlik.service';
import { FileModelloService } from './services/rest/file-modello.service';
import { PasswordDimenticataDialogComponent } from './login/password-dimenticata-dialog/password-dimenticata-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { PasswordScadutaDialogComponent } from './login/password-scaduta-dialog/password-scaduta-dialog.component';
import { CambioObiettivoService } from './services/rest/cambio-obiettivo.service';
import { CambioBceService } from './services/rest/cambio-bce.service';

// // import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  // return new MultiTranslateHttpLoader(http, [
  //     {prefix: './assets/i18n/', suffix: '.json'}, // traduzioni standard
  //     {prefix: './assets/i18n/altre-traduzioni/', suffix: '.json'}, // traduzioni su altri file...
  //   ]);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const services = [
  AuthGuard,
  DatePipe
];

@NgModule({
  declarations: [
    LoginComponent,
    PasswordDimenticataDialogComponent,
    PasswordScadutaDialogComponent,
//     ErrorComponent,
    SidebarComponent,
    MainComponent,
    NavbarComponent
  ],
  providers: [
    CambiService,
//     CookieService,
    ...services
  ],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
//     HttpClientXsrfModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    TooltipModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    }),
    CardModule,
//     ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    NgxSpinnerModule,
    NgProgressModule,
    SpinnerModule,
    NgxWebstorageModule.forRoot(),
    DialogModule
  ],
  exports: [
    AppRoutingModule,
    HttpClientModule,
//     HttpClientXsrfModule,
//     RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgProgressModule,
//     ServiceWorkerModule,
    TranslateModule,
    NgxSpinnerModule
  ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
              // private iconLibrary: FaIconLibrary) {
//     if (parentModule) {
//       throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
//     }
  }

  static forRoot(): ModuleWithProviders<unknown> {
    return {
      ngModule: CoreModule,
      providers: [
        ErrorHandlerInterceptor,
        RestHttpInterceptor,
        AccountService,
        I18nService,
//         RouterBackService,
        StateStorageService,
        StorageService,
        UserService,
        UtilsService,
        SimulativoService,
        DominioCrossService,
        PricingService,
        GroupService,
        QlikService,
        FileModelloService,
        CambioObiettivoService,
        CambioBceService,
//         FormUtilsService,
//         {
//           provide: LocationStrategy,
//           useClass: HashLocationStrategy
//         },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RestHttpInterceptor, multi: true },
        ...services
      ]
    };
  }
}